// @flow
import React from 'react';
import {withRouter} from 'react-router-dom';
import './BreadcrumbsContainer.css';

export type Props = {
  project: ?any,
  history: Object,
};

const BreadcrumbsContainer = (props: Props) => {
  const {project, history} = props;

  return (
    <div className="BreadcrumbsContainer">
      {project &&
        <span onClick={() => history.push(`/projects/${project.id}`)}>
          {project.name}
        </span>
      }
    </div>
  );
};

export default withRouter(BreadcrumbsContainer);



// WEBPACK FOOTER //
// ./src/containers/BreadcrumbsContainer/BreadcrumbsContainer.js